export default "__VITE_ASSET__Bwaocp2g__"